/**
 * SHA256 hashing for martech dataLayer use (e.g. PebblePost {@code hem_value}).
 * Normalizes email the same way Thorne / customer flows do: trim + lowercase.
 */
export async function sha256Hex(email: string | null | undefined): Promise<string | undefined> {
  const normalized = (email ?? '').trim().toLowerCase()
  if (!normalized) {
    return undefined
  }

  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(normalized))
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')
}
